import { gql } from '@apollo/client';
import { useGraphql } from 'utils/hooks/useGraphql';
import { GraphQLResponsePaginationInfo, SortDirection, Sorting } from 'modules/graphql';
import { getTotalPages } from '../utils/getTotalPages';

type FetchBulkResult = {
  results: { name: string }[];
  paginationInfo: GraphQLResponsePaginationInfo;
};

type QueryResult = {
  fetchSnippets?: FetchBulkResult;
};

export const query = gql`
  query FetchSnippetNames($pagination: Pagination, $sort: Sort) {
    fetchSnippets(pagination: $pagination, sort: $sort) {
      results {
        name
      }
      paginationInfo {
        count
        offset
        limit
        page
      }
    }
  }
`;

export const useSnippetNamesQuery = (page: number, pageSize: number) => {
  const {
    networkStatus,
    data: {
      fetchSnippets: {
        paginationInfo: { count = 0 } = {},
        results = [],
      } = {},
    } = {},
  } = useGraphql<QueryResult>(query, {
    variables: {
      pagination: {
        offset: (page - 1) * pageSize,
        limit: pageSize,
      },
      sort: {
        sortBy: Sorting.Name,
        sortDirection: SortDirection.Ascending,
      },
    },
  });

  const totalPages = getTotalPages(pageSize, count);
  const snippetNames = results.map(({ name }) => name);

  return {
    networkStatus,
    totalPages,
    snippetNames,
  };
};
